<tt-page class="col-xs-12 col-md-4 sp-0">
    <tt-card>
        <tt-tabs [(ttSelectedId)]="selectedBgComponentSelection" (ttSelectedIdChange)="onTabChanged()">
            <tt-tab ttId="MINE" ttLabel="pofinishcomps_mine"></tt-tab>
            <tt-tab ttId="ALL" ttLabel="pofinishcomps_all"></tt-tab>
        </tt-tabs>
    </tt-card>

    <tt-list [ttData]="itemsListComponents"></tt-list>
</tt-page>
